import React from "react";
import contextProvider from "../../../contextProvider";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";
import Cookies from "universal-cookie";
import Section from "../../../_L1_components/Layout/Section";
import ReactOCarousel from "app/_L1_components/Elements/ReactOCarousel";

import ReactOButton from "../../../_L1_components/Elements/ReactOButton";
import { ButtonGroup } from "reactstrap";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import Panel from "../../../_L1_components/Layout/Panel";

import ProbeCard from "../../Elements/ProbeCard";

class ProbesView extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,

      firstLoad: null,
    };
    super(props, initState);
    this.cookies = new Cookies();
    this.apiStore = null;
    this.actionsShelf = null;
    this._REFRESH_TOUT = null;
    this._LOADING_ENABLED = true;

    this._viewMode = "all";
  }

  switchView(mode) {
    if (mode == "all" && this._viewMode != mode) {
      this._viewMode = "all";
      // this.getAppContext().getLocalStorageService().set('probes_view_mode', 'all');

      this.forceUpdate();
    } else if (mode == "status_1" && this._viewMode != mode) {
      this._viewMode = "status_1";
      // this.getAppContext().getLocalStorageService().set('probes_view_mode', 'status_1');

      this.forceUpdate();
    } else if (mode == "status_0" && this._viewMode != mode) {
      this._viewMode = "status_0";
      // this.getAppContext().getLocalStorageService().set('probes_view_mode', 'status_0');

      this.forceUpdate();
    }
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionsShelf = this.getAppContext().getActionsShelfService();
    this.loadProbes(null, true);
    this.setState({ loadedCookie: this.cookies.get("reacto_auth") });
  }

  loadProbes(cb, fast) {
    if (this._REFRESH_TOUT || this.mounted == false) {
      clearTimeout(this._REFRESH_TOUT);
    }
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("probes", {
          data: {
            fast: fast ? "1" : "0",
          },
          ___onSuccess: (status, data) => {
            // console.log("DATA from probesview");
            // console.log(data);
            if (this.mounted) {
              let sortedProbes = data.sort(function (a, b) {
                return a.name.trim().localeCompare(b.name.trim());
              });

              this.setState(
                {
                  data: sortedProbes,
                  firstLoad: fast ? true : false,
                  loading: false,
                },
                () => {
                  if (fast) {
                    this._LOADING_ENABLED = false;
                    this.loadProbes(null, false);
                  } else {
                    this._LOADING_ENABLED = false;
                    this._REFRESH_TOUT = setTimeout(() => {
                      const currCookie = this.cookies.get("reacto_auth");
                      if (this.state.loadedCookie == currCookie) {
                        this.loadProbes(null, false);
                      } else {
                        window.location.reload();
                      }
                    }, 60000);
                  }
                },
              );
            }
          },
        });
      },
    );
  }

  onComponentWillUnmount() {
    this.mounted = false;
    if (this._REFRESH_TOUT) {
      clearTimeout(this._REFRESH_TOUT);
    }
  }

  onRender() {
    // if (this.getAppContext().getLocalStorageService().isSet('probes_view_mode')) {
    // 	this._viewMode = this.getAppContext().getLocalStorageService().get('probes_view_mode');
    // }
    // else {
    // 	this._viewMode = 'all';
    // 	this.getAppContext().getLocalStorageService().set('probes_view_mode', 'all');
    // }
    return (
      <Section designType="narrow">
        <_LoadingWrapper
          loadingPlug={this.state.loading && this._LOADING_ENABLED}
          //	hideOnLoading={this._BOOTSTRAP_LOAD_DONE ? false : true}
          minHeight
        >
          {this.state.data && this.state.data.length > 0 ? (
            <div>
              <div className="d-flex justify-content-between align-items-center mt-4 pt-3 mb-3 border-bottom border-2 border-primary">
                <strong>
                  DEPLOYED{" "}
                  {this.state.data && this.state.data[0].sync_status != null
                    ? "(" +
                      (this.state.data.filter((_C_probe) => {
                        return (
                          _C_probe.sync_status == 1 &&
                          _C_probe.probe_status == "deployed"
                        );
                      }).length +
                        this.state.data.filter((_C_probe) => {
                          return (
                            _C_probe.sync_status == 0 &&
                            _C_probe.probe_status == "deployed"
                          );
                        }).length) +
                      ")"
                    : "-"}
                </strong>
                <div className="align-self-end">
                  <ReactOActionBar
                    className="mb-3" // p-3 border-bottom border-3 border-gray300
                    padding="0"
                  >
                    <ButtonGroup>
                      <ReactOButton
                        size="md"
                        color={this._viewMode == "all" ? "primary" : "light"}
                        onClick={() => {
                          this.switchView("all");
                        }}
                        disabled={
                          this.state.data &&
                          this.state.data[0].sync_status == null
                        }
                      >
                        <strong>All</strong>
                      </ReactOButton>
                      <ReactOButton
                        size="md"
                        color={
                          this._viewMode == "status_1" ? "primary" : "light"
                        }
                        onClick={() => {
                          this.switchView("status_1");
                        }}
                        disabled={
                          this.state.data &&
                          this.state.data[0].sync_status == null
                        }
                      >
                        <strong>
                          Online{" "}
                          {this.state.data &&
                          this.state.data[0].sync_status != null
                            ? "(" +
                              this.state.data.filter((_C_probe) => {
                                return (
                                  _C_probe.sync_status == 1 &&
                                  _C_probe.probe_status == "deployed"
                                );
                              }).length +
                              ")"
                            : " - "}
                        </strong>
                      </ReactOButton>
                      <ReactOButton
                        size="md"
                        color={
                          this._viewMode == "status_0" ? "primary" : "light"
                        }
                        onClick={() => {
                          this.switchView("status_0");
                        }}
                        disabled={
                          this.state.data &&
                          this.state.data[0].sync_status == null
                        }
                      >
                        <strong>
                          Offline{" "}
                          {this.state.data &&
                          this.state.data[0].sync_status != null
                            ? "(" +
                              this.state.data.filter((_C_probe) => {
                                return (
                                  _C_probe.sync_status == 0 &&
                                  _C_probe.probe_status == "deployed"
                                );
                              }).length +
                              ")"
                            : " - "}
                        </strong>
                      </ReactOButton>
                    </ButtonGroup>
                  </ReactOActionBar>
                </div>
              </div>
              <div
                className={
                  this.getAppContext().media.isMobile
                    ? ""
                    : "d-flex flex-grow-1"
                }
              >
                <div
                  className={
                    this.getAppContext().media.isMobile ? "mb-2" : "flex-grow-1"
                  }
                ></div>
              </div>
              {this._viewMode == "all" ? (
                <Section
                  designType="wide"
                  layoutManager="grid"
                  elementsPerRow={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? 1
                      : this.getAppContext().media.isDesktopXl
                        ? 2
                        : 3
                  }
                  gridSpacing={20}
                  overflowHidden={true}
                >
                  {this.state.data
                    ? this.state.data
                        .filter((_C_probe) => {
                          return _C_probe.probe_status == "deployed";
                        })
                        .map((_C_probe, _C_idx) => {
                          return (
                            <ProbeCard
                              key={_C_idx}
                              probe_data={_C_probe}
                              firstLoad={this.state.firstLoad}
                              onProbePositionClick={(prb_id) => {
                                if (this.props.onProbePositionClick) {
                                  this.props.onProbePositionClick(prb_id);
                                }
                              }}
                              onProbePhotoClick={() => {
                                let sortedPhoto = _C_probe.photos.slice();

                                sortedPhoto.forEach(function (item, i) {
                                  if (item.fav === 1) {
                                    sortedPhoto.splice(i, 1);
                                    sortedPhoto.unshift(item);
                                  }
                                });

                                this._carousel.open(
                                  sortedPhoto.map((_C_photo, _C_idx) => {
                                    return {
                                      src:
                                        this.getAppContext()
                                          .getApiStoreService()
                                          .getCluster() +
                                        this.getAppContext().conf.API_PATH +
                                        "/utils/prbphotostream/" +
                                        _C_probe.prb_id +
                                        "/" +
                                        _C_photo.filename +
                                        "/0?token=" +
                                        this.getAppContext().authHandler.getToken(),
                                    };
                                  }),
                                );
                              }}
                            />
                          );
                        })
                    : null}
                </Section>
              ) : this._viewMode == "status_1" ? (
                <Section
                  designType="wide"
                  layoutManager="grid"
                  elementsPerRow={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? 1
                      : this.getAppContext().media.isDesktopXl
                        ? 2
                        : 3
                  }
                  gridSpacing={20}
                  overflowHidden={true}
                >
                  {this.state.data && this.state.data[0].sync_status != null
                    ? this.state.data

                        .filter((_C_probe) => {
                          return (
                            _C_probe.sync_status == 1 &&
                            _C_probe.probe_status == "deployed"
                          );
                        })
                        .map((_C_probe, _C_idx) => {
                          return (
                            <ProbeCard
                              key={_C_idx}
                              probe_data={_C_probe}
                              onProbePositionClick={(prb_id) => {
                                if (this.props.onProbePositionClick) {
                                  this.props.onProbePositionClick(prb_id);
                                }
                              }}
                              onProbePhotoClick={() => {
                                this._carousel.open(
                                  _C_probe.photos.map((_C_photo, _C_idx) => {
                                    return {
                                      src:
                                        this.getAppContext()
                                          .getApiStoreService()
                                          .getCluster() +
                                        this.getAppContext().conf.API_PATH +
                                        "/utils/prbphotostream/" +
                                        _C_probe.prb_id +
                                        "/" +
                                        _C_photo.filename +
                                        "/0?token=" +
                                        this.getAppContext().authHandler.getToken(),
                                    };
                                  }),
                                );
                              }}
                            />
                          );
                        })
                    : null}
                </Section>
              ) : this._viewMode == "status_0" || !this._viewMode ? (
                <Section
                  designType="wide"
                  layoutManager="grid"
                  elementsPerRow={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? 1
                      : this.getAppContext().media.isDesktopXl
                        ? 2
                        : 3
                  }
                  gridSpacing={20}
                  overflowHidden={true}
                >
                  {this.state.data && this.state.data[0].sync_status != null
                    ? this.state.data

                        .filter((_C_probe) => {
                          return (
                            _C_probe.sync_status == 0 &&
                            _C_probe.probe_status == "deployed"
                          );
                        })
                        .map((_C_probe, _C_idx) => {
                          return (
                            <ProbeCard
                              key={_C_idx}
                              probe_data={_C_probe}
                              onProbePositionClick={(prb_id) => {
                                if (this.props.onProbePositionClick) {
                                  this.props.onProbePositionClick(prb_id);
                                }
                              }}
                              onProbePhotoClick={() => {
                                this._carousel.open(
                                  _C_probe.photos.map((_C_photo, _C_idx) => {
                                    return {
                                      src:
                                        this.getAppContext()
                                          .getApiStoreService()
                                          .getCluster() +
                                        this.getAppContext().conf.API_PATH +
                                        "/utils/prbphotostream/" +
                                        _C_probe.prb_id +
                                        "/" +
                                        _C_photo.filename +
                                        "/0?token=" +
                                        this.getAppContext().authHandler.getToken(),
                                    };
                                  }),
                                );
                              }}
                            />
                          );
                        })
                    : null}
                </Section>
              ) : null}

              <div>
                {this.state.data &&
                this.state.data.filter((_C_probe) => {
                  return _C_probe.probe_status == "maintenance";
                }).length ? (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 mb-3 border-bottom border-2 border-primary">
                      <strong>
                        MAINTENANCE (
                        {
                          this.state.data.filter((_C_probe) => {
                            return _C_probe.probe_status == "maintenance";
                          }).length
                        }
                        )
                      </strong>
                      <div className="align-self-end">
                        <ReactOActionBar
                          className="mb-3" // p-3 border-bottom border-3 border-gray300
                          padding="0"
                        >
                          <ButtonGroup>
                            <ReactOButton
                              size="md"
                              color={
                                this._viewMode == "all" ? "primary" : "light"
                              }
                              onClick={() => {
                                this.switchView("all");
                              }}
                              disabled={
                                this.state.data &&
                                this.state.data[0].sync_status == null
                              }
                            >
                              <strong>All</strong>
                            </ReactOButton>
                            <ReactOButton
                              size="md"
                              color={
                                this._viewMode == "status_1"
                                  ? "primary"
                                  : "light"
                              }
                              onClick={() => {
                                this.switchView("status_1");
                              }}
                              disabled={
                                this.state.data &&
                                this.state.data[0].sync_status == null
                              }
                            >
                              <strong>
                                Online{" "}
                                {this.state.data &&
                                this.state.data[0].sync_status != null
                                  ? "(" +
                                    this.state.data.filter((_C_probe) => {
                                      return (
                                        _C_probe.sync_status == 1 &&
                                        _C_probe.probe_status == "maintenance"
                                      );
                                    }).length +
                                    ")"
                                  : " - "}
                              </strong>
                            </ReactOButton>
                            <ReactOButton
                              size="md"
                              color={
                                this._viewMode == "status_0"
                                  ? "primary"
                                  : "light"
                              }
                              onClick={() => {
                                this.switchView("status_0");
                              }}
                              disabled={
                                this.state.data &&
                                this.state.data[0].sync_status == null
                              }
                            >
                              <strong>
                                Offline{" "}
                                {this.state.data &&
                                this.state.data[0].sync_status != null
                                  ? "(" +
                                    this.state.data.filter((_C_probe) => {
                                      return (
                                        _C_probe.sync_status == 0 &&
                                        _C_probe.probe_status == "maintenance"
                                      );
                                    }).length +
                                    ")"
                                  : " - "}
                              </strong>
                            </ReactOButton>
                          </ButtonGroup>
                        </ReactOActionBar>
                      </div>
                    </div>

                    <Section
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? 1
                          : this.getAppContext().media.isDesktopXl
                            ? 2
                            : 3
                      }
                      gridSpacing={20}
                      overflowHidden={true}
                    >
                      {this.state.data
                        ? this.state.data
                            .filter((_C_probe) => {
                              return _C_probe.probe_status == "maintenance";
                            })
                            .filter((probe) => {
                              if (this._viewMode == "all") {
                                return true;
                              }
                              if (this._viewMode == "status_1") {
                                return probe.sync_status == 1;
                              }
                              if (this._viewMode == "status_0") {
                                return probe.sync_status == 0;
                              } else {
                                return null;
                              }
                            })
                            .map((_C_probe, _C_idx) => {
                              return (
                                <ProbeCard
                                  key={_C_idx}
                                  probe_data={_C_probe}
                                  onProbePositionClick={(prb_id) => {
                                    if (this.props.onProbePositionClick) {
                                      this.props.onProbePositionClick(prb_id);
                                    }
                                  }}
                                  onProbePhotoClick={() => {
                                    this._carousel.open(
                                      _C_probe.photos.map(
                                        (_C_photo, _C_idx) => {
                                          return {
                                            src:
                                              this.getAppContext()
                                                .getApiStoreService()
                                                .getCluster() +
                                              this.getAppContext().conf
                                                .API_PATH +
                                              "/utils/prbphotostream/" +
                                              _C_probe.prb_id +
                                              "/" +
                                              _C_photo.filename +
                                              "/0?token=" +
                                              this.getAppContext().authHandler.getToken(),
                                          };
                                        },
                                      ),
                                    );
                                  }}
                                />
                              );
                            })
                        : null}
                    </Section>
                  </div>
                ) : null}
              </div>
              <div>
                {this.state.data &&
                this.state.data.filter((_C_probe) => {
                  return _C_probe.probe_status == "not_deployed";
                }).length ? (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 mb-3 border-bottom border-2 border-primary">
                      <strong>
                        NOT DEPLOYED (
                        {
                          this.state.data.filter((_C_probe) => {
                            return _C_probe.probe_status == "not_deployed";
                          }).length
                        }
                        )
                      </strong>
                      <div className="align-self-end">
                        <ReactOActionBar
                          className="mb-3" // p-3 border-bottom border-3 border-gray300
                          padding="0"
                        >
                          <ButtonGroup>
                            <ReactOButton
                              size="md"
                              color={
                                this._viewMode == "all" ? "primary" : "light"
                              }
                              onClick={() => {
                                this.switchView("all");
                              }}
                              disabled={
                                this.state.data &&
                                this.state.data[0].sync_status == null
                              }
                            >
                              <strong>All</strong>
                            </ReactOButton>
                            <ReactOButton
                              size="md"
                              color={
                                this._viewMode == "status_1"
                                  ? "primary"
                                  : "light"
                              }
                              onClick={() => {
                                this.switchView("status_1");
                              }}
                              disabled={
                                this.state.data &&
                                this.state.data[0].sync_status == null
                              }
                            >
                              <strong>
                                Online{" "}
                                {this.state.data &&
                                this.state.data[0].sync_status != null
                                  ? "(" +
                                    this.state.data.filter((_C_probe) => {
                                      return (
                                        _C_probe.sync_status == 1 &&
                                        _C_probe.probe_status == "not_deployed"
                                      );
                                    }).length +
                                    ")"
                                  : " - "}
                              </strong>
                            </ReactOButton>
                            <ReactOButton
                              size="md"
                              color={
                                this._viewMode == "status_0"
                                  ? "primary"
                                  : "light"
                              }
                              onClick={() => {
                                this.switchView("status_0");
                              }}
                              disabled={
                                this.state.data &&
                                this.state.data[0].sync_status == null
                              }
                            >
                              <strong>
                                Offline{" "}
                                {this.state.data &&
                                this.state.data[0].sync_status != null
                                  ? "(" +
                                    this.state.data.filter((_C_probe) => {
                                      return (
                                        _C_probe.sync_status == 0 &&
                                        _C_probe.probe_status == "not_deployed"
                                      );
                                    }).length +
                                    ")"
                                  : " - "}
                              </strong>
                            </ReactOButton>
                          </ButtonGroup>
                        </ReactOActionBar>
                      </div>
                    </div>

                    <Section
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? 1
                          : this.getAppContext().media.isDesktopXl
                            ? 2
                            : 3
                      }
                      gridSpacing={20}
                      overflowHidden={true}
                    >
                      {this.state.data
                        ? this.state.data

                            .filter((_C_probe) => {
                              return _C_probe.probe_status == "not_deployed";
                            })
                            .filter((probe) => {
                              if (this._viewMode == "all") {
                                return true;
                              }
                              if (this._viewMode == "status_1") {
                                return probe.sync_status == 1;
                              }
                              if (this._viewMode == "status_0") {
                                return probe.sync_status == 0;
                              } else {
                                return null;
                              }
                            })
                            .map((_C_probe, _C_idx) => {
                              return (
                                <ProbeCard
                                  key={_C_idx}
                                  probe_data={_C_probe}
                                  onProbePositionClick={(prb_id) => {
                                    if (this.props.onProbePositionClick) {
                                      this.props.onProbePositionClick(prb_id);
                                    }
                                  }}
                                  onProbePhotoClick={() => {
                                    this._carousel.open(
                                      _C_probe.photos.map(
                                        (_C_photo, _C_idx) => {
                                          return {
                                            src:
                                              this.getAppContext()
                                                .getApiStoreService()
                                                .getCluster() +
                                              this.getAppContext().conf
                                                .API_PATH +
                                              "/utils/prbphotostream/" +
                                              _C_probe.prb_id +
                                              "/" +
                                              _C_photo.filename +
                                              "/0?token=" +
                                              this.getAppContext().authHandler.getToken(),
                                          };
                                        },
                                      ),
                                    );
                                  }}
                                />
                              );
                            })
                        : null}
                    </Section>
                  </div>
                ) : null}
              </div>
            </div>
          ) : this.state.loading == false ? (
            <div className="mt-4">
              <Panel bodyClassName="p-4" rounded>
                <span className="py-3"> No probes data</span>
              </Panel>
            </div>
          ) : null}
        </_LoadingWrapper>
        <ReactOCarousel
          modal
          modalTitle="Probe's photos"
          onControllerReady={(carousel_context) => {
            this._carousel = carousel_context;
          }}
        />
      </Section>
    );
  }
}

export default contextProvider(ProbesView, {
  retrieve: [],
});
